import { render, staticRenderFns } from "./AgreementTabs.vue?vue&type=template&id=26b9d08e&lang=pug"
import script from "./AgreementTabs.vue?vue&type=script&lang=js"
export * from "./AgreementTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports